import React from 'react';
import useDevice from '../../../hooks/useDevice.mjs';
import { FontWeight } from '../../../styles/theme.mjs';
import HorizontalCarousel from '../HorizontalCarousel/HorizontalCarousel.mjs';
import { StyledFlexContainer, StyledCategoryTitle, StyledPromotionalCarouselImageContainer, StyledPromotionalCarouselImage } from './PromotionalCarousel.styles.mjs';

const PromotionalCarousel = ({ items, title }) => {
    const { isMobile } = useDevice();
    return (React.createElement(StyledFlexContainer, { direction: "column", gap: "1.5rem" },
        title && (React.createElement(StyledCategoryTitle, { withMarker: true, uppercased: true, fontWeight: FontWeight.Semibold, tag: "h5" }, title)),
        React.createElement(HorizontalCarousel, { showArrows: false, options: { active: isMobile } }, items.map(item => (React.createElement(StyledPromotionalCarouselImageContainer, { key: item.id, href: item.href },
            React.createElement(StyledPromotionalCarouselImage, { src: item.imageSrc, alt: item.alt })))))));
};

export { PromotionalCarousel as default };
//# sourceMappingURL=PromotionalCarousel.mjs.map
